import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n'
import router from './router'
import store from './store'
import "./libraries/filters"

Vue.config.productionTip = false;

Vue.prototype.$PERMIT_API = process.env.VUE_APP_PERMIT_API;
Vue.prototype.$PERMIT_VOLUME_API = process.env.VUE_APP_PERMIT_VOLUME_API;
Vue.prototype.$PERMIT_DETAILS_API = process.env.VUE_APP_PERMIT_DETAILS_API;
Vue.prototype.$DEVELOPMENT_PERMIT_API = process.env.VUE_APP_DEVELOPMENT_PERMIT_API;
Vue.prototype.$DEVELOPMENT_VOLUME_API = process.env.VUE_APP_DEVELOPMENT_VOLUME_API;
Vue.prototype.$LANG = process.env.VUE_APP_I18N_LOCALE;

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
